/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { useGoogleLogin } from '@react-oauth/google';

import getValidationErros from '~/utils/getValidationsErrors';
import { useAuth } from '~/hooks/Auth';

import { Container } from './styles';
import Input from '~/components/Input';
import { KrGoogle, KrHome } from '~/components/KoroIcons';

import logo from '~/assets/logos/logo-name.svg';
import ButtonBack from '~/components/ButtonBack';

interface IFormData {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const { signIn, signInGoogle } = useAuth();
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string().required('O e-mail é obrigatório'),
          password: Yup.string().required('A senha é obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        signIn({
          email: data.email,
          password: data.password,
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Credenciais inválidas!');
        }
      }
    },
    [signIn]
  );

  const handleSuccess = useCallback(
    (data) => {
      signInGoogle(data);
    },
    [signInGoogle]
  );

  const handleFailure = useCallback(() => {
    Swal.fire(
      'Oops...',
      'Ocorreu um erro ao realizar o login com google tente novamente ou contate o administrador!'
    );
  }, []);

  const googleLogin = useGoogleLogin({
    onSuccess: handleSuccess,
    onError: handleFailure,
  });

  useEffect(() => {
    if (window.ReactNativeWebView) {
      document.addEventListener('message', (event: any) => {
        const data = JSON.parse(event.data);
        handleSuccess(data);
      });
    }
  }, [handleFailure, handleSuccess]);

  const handleClickGoogleLogin = useCallback(() => {
    if (window.ReactNativeWebView) {
      const data = {
        googleLogin: true,
      };

      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    } else {
      googleLogin();
    }
  }, [googleLogin]);

  return (
    <Container>
      <div className="container">
        <div className="row justify-content-center">
          {window.ReactNativeWebView && (
            <div className="col-12">
              <ButtonBack
                href={`${process.env.PUBLIC_URL}/`}
                className="mt-3 text-white"
              />
            </div>
          )}
          <div className="col-12 text-center">
            <Link to={`${process.env.PUBLIC_URL}/`} className="btn-home">
              <KrHome size={22} color="#fff" />
            </Link>
            <div className="ret-up ret-left" />
            <div className="ret-up ret-right" />
            <Link to={`${process.env.PUBLIC_URL}/`}>
              <img src={logo} alt="Logo Koro" className="logo" />
            </Link>
          </div>

          <div className="col-11 px-3">
            <h2 className="h6 text-white fw-normal mb-3">
              Faça login para continuar
            </h2>
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              className="d-flex flex-column pb-3"
            >
              <label className="mb-3">
                <span className="text-white fw-normal d-block mb-2 size">
                  E-mail
                </span>
                <Input type="email" name="email" />
              </label>
              <label className="mb-3">
                <span className="text-white fw-normal d-block mb-2 size">
                  Senha
                </span>
                <Input type="password" name="password" />
              </label>

              <button
                type="submit"
                className="btn btn-login h6 fw-normal py-2 mt-4"
              >
                Entrar
              </button>
              <span className="text-center text-white opacity-50 fw-normal d-block size">
                ou
              </span>
              <button
                type="button"
                className="d-flex align-items-center justify-content-center btn btn-login h6 fw-normal py-2 mt-2"
                onClick={() => handleClickGoogleLogin()}
              >
                <KrGoogle size={20} color="#FF6900" className="g-icon me-2" />{' '}
                Entrar com Google
              </button>
            </Form>
            <p className="text-center small text-white">
              <span className="opacity-75">Esqueceu sua senha?</span>{' '}
              <Link
                to={`${process.env.PUBLIC_URL}/recuperar-senha`}
                className="opacity-100 text-white text-decoration-underline"
              >
                Recuperar.
              </Link>
            </p>
            <p className="text-center mb-1 small text-white mt-3">
              <span className="opacity-75">Não tem uma conta?</span>{' '}
            </p>
            <Link
              to={`${process.env.PUBLIC_URL}/cadastro`}
              className="w-100 btn btn-login"
            >
              Cadastre-se aqui
            </Link>
          </div>
        </div>
      </div>
      {/* <img src={retanglesBottom} alt="background" className="ret-bottom" /> */}
    </Container>
  );
};

export default Login;
